import React from 'react';

const CommentBubble: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 36" {...props}>
    <path
      fill="currentColor"
      d="M20 .292C9.47.292.903 7.35.903 16.027a14.28 14.28 0 005.265 10.86L2.361 34.5a.833.833 0 001.096 1.128l10.21-4.753c2.06.592 4.191.89 6.334.887 10.531 0 19.098-7.059 19.098-15.735C39.099 7.35 30.532.292 20.001.292zm8.334 20.416H12.501a1.25 1.25 0 010-2.5h15.833a1.25 1.25 0 010 2.5zm-17.083-8.75a1.25 1.25 0 011.25-1.25h10.833a1.25 1.25 0 010 2.5H12.501a1.25 1.25 0 01-1.25-1.25z"
    ></path>
  </svg>
);

export default CommentBubble;
